/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BankListItemViewModelPaginatedResponse } from "../types/BankListItemViewModelPaginatedResponse.ts";
import { bankListItemViewModelSchema } from "./bankListItemViewModelSchema.ts";

export const bankListItemViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => bankListItemViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<BankListItemViewModelPaginatedResponse>;
